var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBigpattern = function SvgBigpattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 538 573"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ECF8F8",
    cx: 242.5,
    cy: 330.5,
    r: 242.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.375 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.063 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.438 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.125 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452.75 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.188 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.563 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.813 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.25 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.625 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.875 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 126.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 21.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 147.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 42.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 168.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 252.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 63.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 189.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 273.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 84.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 210.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 294.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.313 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 105.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.688 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 231.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.938 315.938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.063v21.063H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 10.531,
    cy: 10.531,
    r: 3.949
  })))));
};
export default __webpack_public_path__ + "static/bigpattern.1d9aac64.svg";
export { SvgBigpattern as ReactComponent };